<template>
  <td
    @click="onClick"
    :class="[
      { 'is-pointer': onClickRow !== undefined && !field.preventOnClick },
      customClass,
    ]"
  >
    <p v-if="field.ref !== undefined" v-html="render(desrefer, item)"></p>
    <component
      v-if="field.component !== undefined"
      :is="field.component"
      :field="field"
      :item="item"
      @reloadTable="reloadTable"
    ></component>
    <template v-else></template>
  </td>
</template>

<script>
export default {
  name: "date-viewer-cel",
  props: {
    item: {
      type: Object,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    onClickRow: Function,
  },
  methods: {
    render(value, item) {
      return this.field.render !== undefined
        ? this.field.render(value, item)
        : value;
    },
    onClick() {
      if (!this.field.preventOnClick) {
        this.onClickRow(this.item);
      }
    },
    reloadTable() {
      this.$emit("reloadTable");
    },
  },
  computed: {
    desrefer() {
      let value = this.item;
      let refs = this.field.ref.split(".");

      for (var i = 0; i < refs.length; ++i) {
        value = value[refs[i]];
      }

      return value;
    },
    customClass() {
      return this.field.cellClass !== undefined ? this.field.cellClass : "";
    },
  },
};
</script>